import EventManager from "../../../../manager/event_manager";
import { TaskHelp } from "./task_help";
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";
import ModelData from "../../../public/model_data";

export class TaskDataCache{

    public static instance : TaskDataCache = new TaskDataCache();

    private mData:Map<string,Map<number,any>>;

    private uid:number;

    constructor(){
        this.init()
    }

    private init(){
        this.mData = new Map();
        EventManager.instance.on('Event_Notify_Data', this.on_msg_coming, this, true)
    }

    getTaskData(taskCode:string,finish:Function,mvvbase:MVVMBase,isNeedUpdate:boolean=false,){
        if (this.uid == undefined || this.uid != ModelData.instance.roleData.id) {
            this.clear();
            this.uid = ModelData.instance.roleData.id;
        }
        let taskItems = this.mData.get(taskCode);
        let isUseCache = taskItems != undefined && taskItems.size > 0;
        if (isUseCache) {//使用缓存数据
            let arry = Array.from(taskItems.values());
            finish(arry);//无需排序
        }else{
            this.mData.set(taskCode,new Map<number,any>());
        }   
        let self = this;
        TaskHelp.getUserTask([taskCode],(data:any[])=>{//更新数据
            let items = this.mData.get(taskCode);
            if (items) {
                items.clear();
            }
            let sortdata = this.sortTask(taskCode,data[0]);
            this.mData.set(taskCode,self.getTaskMap(sortdata));
            isNeedUpdate && finish(sortdata);
        },mvvbase);
    }

    protected on_msg_coming(msg){
        if (msg.notifyType == "broadcast") {
        }else if (msg.notifyType == 'new_mail') {
        }else if(msg.notifyType == "task_process_update"){
            let items = JSON.parse(msg.content)
            if (items) {
                for (let i = 0; i < items.length; i++) {
                    let item = items[i];
                    this.updateTaskItem(item.taskTypeCode,item.taskRefId,item);
                }
            }
        }
    }

    //任务数据更新--针对单个数据的更新
    private updateTaskItem(taskCode:string,taskRefId:number,data:any){
        let item = this.mData.get(taskCode);
        if (item && item.size > 0) {
            let value = item.get(taskRefId);
            if (value) {//数据更新
                value.conditionVal = data.conditionVal;
                value.currentConditionVal = data.currentConditionVal;
                value.isFinish = data.isFinish;
                value.isReceive = data.isReceive;
                item.set(taskRefId,value);
            }
        }
    }

  
    private getTaskMap(arry:any[]):Map<number,any>{
        let map = new Map<number,any>();
        for (let i = 0; i < arry.length; i++) {
            let data = arry[i];
            map.set(data.taskRefId,data);
        }
        return map;
    }

    //任务排序
    private sortTask(taskcode:string,arry:any[]){
        //每日任务
        //1.可领取 2.需要去完成的 3.已经超时了 4.已经完成了
        let sortEveryDayFunc = (a,b)=>{
            let aTaskCanReceive = a.isFinish && !a.isReceive
            let bTaskCanReceive = b.isFinish && !b.isReceive
            if (aTaskCanReceive && bTaskCanReceive) {//可领取
                return -1;//排在最前面
            }else if (!aTaskCanReceive && !bTaskCanReceive) {//不能领取
                //1.未完成 2.已经完成的
               if (!a.isFinish && !b.isFinish) {
                   return a.isFinish > b.isFinish ? -1:1;
               }else{
                   return a.isReceive < b.isReceive ? -1:1;
               }
            }else{
                return aTaskCanReceive > bTaskCanReceive ? -1:1
            }
        }

        arry.sort(sortEveryDayFunc)
        return arry;
    }

    clear(){
        this.mData.forEach((v:Map<number,any>,k:string)=>{
            v.clear();
        })
        this.mData.clear();
    }

}
